wbApp.filter('contractScheduleShort', ['$translate', function ($translate) {

    /*
        "contractSchedules": [
            {
                "id": "e845febe-9e2f-4dd3-93eb-6d055f81c476",
                "fromDate": "2022-01-01T00:00:00",
                "toDate": "2022-04-01T00:00:00",
                "monday": {
                    "startTime": 480,
                    "endTime": 960,
                    "food": true
                },
                "tuesday": {
                    "startTime": 480,
                    "endTime": 960,
                    "food": true
                },
                "wednesday": {
                    "startTime": 480,
                    "endTime": 840,
                    "food": true
                }
            }
        ]    
     */
    
    return function (input) {
        if (input) {
            
            return _.reduce(input, function(result, schedule) {
                if (!!result) {
                    result += " | ";
                }
                result += moment(schedule.fromDate).format('DD.MM.YY') + ' - ' + moment(schedule.toDate).format('DD.MM.YY') + ' [';
                
                let days = [];
                if (!!schedule.monday) {
                    days.push($translate.instant('TXT_MONDAY_SHORT'));
                }
                if (!!schedule.tuesday) {
                    days.push($translate.instant('TXT_TUESDAY_SHORT'));
                }
                if (!!schedule.wednesday) {
                    days.push($translate.instant('TXT_WEDNESDAY_SHORT'));
                }
                if (!!schedule.thursday) {
                    days.push($translate.instant('TXT_THURSDAY_SHORT'));
                }
                if (!!schedule.friday) {
                    days.push($translate.instant('TXT_FRIDAY_SHORT'));
                }
                if (!!schedule.saturday) {
                    days.push($translate.instant('TXT_SATURDAY_SHORT'));
                }
                if (!!schedule.sunday) {
                    days.push($translate.instant('TXT_SUNDAY_SHORT'));
                }
                
                return result + days.join(',') + ']';
            }, '');
        }
    };
}]);